import {DownloadPageData} from '../types';
import {default as escape} from 'escape-html';
import {InviteParameters} from './interface';

const renderAvatarWithName = ({
  firstName,
  avatarUri,
  fallbackText = 'us',
  avatarSize = 'small',
}: {
  firstName?: string;
  avatarUri?: string;
  fallbackText: string;
  avatarSize?: 'small' | 'large';
}) =>
  firstName
    ? `<div class="avatar-container">${
        avatarUri
          ? `![avatar${avatarSize === 'large' ? '-large' : ''}](${avatarUri})`
          : ''
      }<span class="username">${escape(firstName)}</span></div>`
    : fallbackText;

export const downloadPageData_ShareStory: DownloadPageData<InviteParameters> = {
  text: {
    en: ({
      inviterFirstName,
      inviterAvatarUri,
      authorFirstName,
      authorAvatarUri,
      inviterProfileId,
      authorProfileId,
    }: InviteParameters) =>
      inviterProfileId === authorProfileId
        ? `# Join ${renderAvatarWithName({
            firstName: inviterFirstName,
            avatarUri: inviterAvatarUri,
            fallbackText: 'us',
            avatarSize: 'large',
          })} on ![titleLogo](/logo.svg)\n ## Check out ${renderAvatarWithName({
            firstName: authorFirstName,
            avatarUri: authorAvatarUri,
            fallbackText: 'this',
          })}'s story on Slip 🤩!${
            authorFirstName
              ? `  \nTap this text after installing to find ${authorFirstName}'s content.`
              : `  \nTap this text after installing to find the content.`
          }`
        : `# Check out ${renderAvatarWithName({
            firstName: authorFirstName ? authorFirstName + "'s" : undefined,
            avatarUri: authorAvatarUri,
            fallbackText: 'this',
            avatarSize: 'large',
          })} story on ![titleLogo](/logo.svg)\n ## ${renderAvatarWithName({
            firstName: inviterFirstName,
            avatarUri: inviterAvatarUri,
            fallbackText: 'We',
          })} ${
            inviterFirstName ? 'thinks' : 'think'
          } you'll enjoy this story!${
            authorFirstName
              ? `  \nTap this text after installing to find ${authorFirstName}'s content.`
              : `  \nTap this text after installing to find the content.`
          }`,
    nl: ({
      inviterFirstName,
      inviterAvatarUri,
      authorFirstName,
      authorAvatarUri,
      inviterProfileId,
      authorProfileId,
    }: InviteParameters) =>
      inviterProfileId === authorProfileId
        ? `# Join ${renderAvatarWithName({
            firstName: inviterFirstName,
            avatarUri: inviterAvatarUri,
            fallbackText: 'ons',
            avatarSize: 'large',
          })} op ![titleLogo](/logo.svg)\n ## Check ${renderAvatarWithName({
            firstName: authorFirstName,
            avatarUri: authorAvatarUri,
            fallbackText: 'deze',
          })}'s content op Slip 🤩!${
            authorFirstName
              ? `  \nKlik hier na het installeren om ${authorFirstName}'s content te vinden.`
              : `  \nKlik hier na het installeren om de content te vinden.`
          }`
        : `# Check ${renderAvatarWithName({
            firstName: authorFirstName ? authorFirstName + "'s" : undefined,
            avatarUri: authorAvatarUri,
            fallbackText: 'deze',
            avatarSize: 'large',
          })} bericht op ![titleLogo](/logo.svg)\n ## ${renderAvatarWithName({
            firstName: inviterFirstName,
            avatarUri: inviterAvatarUri,
            fallbackText: 'We',
          })} ${
            inviterFirstName ? 'denkt' : 'denken'
          } dat je deze content zal waarderen!${
            authorFirstName
              ? `  \nKlik hier na het installeren om ${authorFirstName}'s content te vinden.`
              : `  \nKlik hier na het installeren om de content te vinden.`
          }`,
  },
  platforms: {
    iOS: {
      url: 'https://apps.apple.com/us/app/slip-app/id6449608428',
    },
    Android: {
      url: 'https://play.google.com/store/apps/details?id=com.slipbv.slipapp&utm_source=website&utm_campaign=invite-2025&pcampaignid=invite-share-story-2025-webpage',
    },
  },
};
